var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('Banner'),_c('About'),_c('Team'),_c('Services'),_c('Stats'),_c('Products',{on:{"show-modal":function($event){_vm.showModal = true}}}),_c('Brands'),_c('Contact'),(_vm.showModal)?_c('Product',{on:{"close-modal":function($event){_vm.showModal = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }